/**
 * Endonyms (self-names) for every locale Reflecto ships — the labels the
 * language picker shows. Endonyms are by definition written in their own
 * language and are NEVER translated, so this is plain shared data, not a
 * catalog concern; both browser surfaces render the same list.
 *
 * Keys are the catalog registry tags (web `catalogs` / extension `_locales`
 * dirs modulo underscore). Adding a locale to the product means adding it
 * here too — the picker derives its options from the intersection of this
 * map and the host's registered catalogs, so a missing entry hides the
 * locale from the picker rather than rendering a raw tag.
 */
export const LOCALE_ENDONYMS: Record<string, string> = {
  cs: "Čeština",
  da: "Dansk",
  de: "Deutsch",
  el: "Ελληνικά",
  en: "English",
  es: "Español",
  fi: "Suomi",
  fr: "Français",
  hi: "हिन्दी",
  hu: "Magyar",
  id: "Bahasa Indonesia",
  it: "Italiano",
  ja: "日本語",
  ko: "한국어",
  ms: "Bahasa Melayu",
  nb: "Norsk bokmål",
  nl: "Nederlands",
  pl: "Polski",
  "pt-BR": "Português (Brasil)",
  ro: "Română",
  ru: "Русский",
  sv: "Svenska",
  th: "ไทย",
  tr: "Türkçe",
  uk: "Українська",
  vi: "Tiếng Việt",
  "zh-CN": "简体中文",
  "zh-TW": "繁體中文",
};
